<template>
	<div class="main-table-freight">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				border
				stripe
				@row-dblclick='rowClick'
				:height="tableHeight"
				ref="table"
				@select="handleSelectionChange"
				@select-all="handleSelectionChange"
			>
				<el-table-column
					type="selection"
					align="center"
					width="50">
				</el-table-column>
				<el-table-column
					prop="selfPickName"
					label="自提点名称"
					align="center">
					<template slot-scope="scope">
						<div>
							<el-tooltip class="item" effect="dark" :content="scope.row.selfPickName" placement="top-start">
								<span>{{scope.row.selfPickName.substring(0, 15)}}<span v-if="scope.row.selfPickName.length > 15">...</span></span>
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="selfPickAddress"
					label="详细地址"
					align="center">
					<template slot-scope="scope">
						<div>
							<el-tooltip class="item" effect="dark" :content="scope.row.selfPickAddress" placement="top-start">
								<span>{{scope.row.selfPickAddress.substring(0, 15)}}<span v-if="scope.row.selfPickAddress.length > 15">...</span></span>
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="selfPickLinkName"
					label="联系人"
					align="center">
				</el-table-column>
				<el-table-column
					prop="createDate"
					label="创建时间"
					align="center">
				</el-table-column>
				<el-table-column
					prop="selfPickTel"
					label="联系电话"
					align="center">
				</el-table-column>
				<el-table-column
					prop="selfPickMoney"
					label="自提费用"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.selfPickMoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="customerLevel"
					label="自提时间"
					min-width="140"
					align="center">
					<template slot-scope="scope">
						<div v-for="item in scope.row.selfPickTimes" :key="item.selfPickDate">{{item.beginDate}}~{{item.endDate}} ({{item.selfPickDate}})</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="220" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="goEdit(scope.row.id)" v-if="AuthorityList['01_0008_0002_00']">编辑</el-button>
						<el-button type='text' size="mini" @click="deleteSelf(scope.row.id)" v-if="AuthorityList['01_0008_0003_00']">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20, 40, 60, 100, 300]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		AuthorityList: {
			type: Object
		},
		needauditingflag: Boolean,
		canundeliveredunpaysendflag: Boolean
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			},
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'id'
			}),
			dialogModel: false,
			templateType: -1,
			templateName: '',
			templateList: [],
			temTotalCount: 0,
			temNormalCount: 0,
			temSpecCount: 0,
			chooseData: {},
			chooseId: ''
		}
	},
	created () {
		// this.getAuthority('07_0001_0000_00')
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		goEdit (id) {
			this.$router.push({ path: '/main/selfDeliveryEdit', query: { id: id } })
		},
		deleteSelf (id) {
			this.$confirm('是否要删除？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					ids: [id]
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/deleteShopSelfPickInfo`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功！')
						this.$emit('modifySuc')
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		},
		initIschoose () {
			this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
		},
		rowClick (row, column, event) {
			if (this.AuthorityList['01_0008_0002_00']) {
				this.goEdit(row.id)
			}
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			let value = this.tableSelectUtils.getSelectRows()
			let ids = value.map(item => {
				return item.id
			})
			this.$emit('selectIds', ids)
		},
		getDetail (value) {
			window.sessionStorage.setItem('percentageId', value.planid)
			this.$router.push(`/main/percentageDetail`)
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table-freight {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.main-table-box {
		flex: 1
		width: 100%
		// padding-bottom 10px
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
	}
	.over-hidden{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	.type-box {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 15px;
	}
	.template-list {
		flex: 1;
		margin-top: 15px;
		max-height: 350px;
		color: #333;
		overflow: hidden
		overflow-y: auto
		.template-li {
			border: 1px solid #EDEFFC;
			box-shadow: 0px 1px 4px 1px rgba(199, 199, 199, 0.23);
			border-radius: 2px;
			.template-head {
				display: flex;
				height: 38px;
				padding: 0 10px;
				background-color: #EFEFEF;
				align-items: center;
				cursor: pointer
				i {
					margin-right: 5px
				}
				img {
					margin-right: 5px;
				}
				.head-right {
					margin-left: auto;
					span {
						margin-right: 5px
					}
				}
			}
		}
	}
	.under-line {
		cursor: pointer;
		text-decoration: underline
	}
	.btn-box {
		text-align: right;
		margin-top: 15px;
	}
}
</style>
<style lang="stylus">
.main-table-freight {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	// .el-radio-group {
	// 	display flex
	// 	flex-direction: column
	// 	padding: 0 15px 20px
	// 	.el-radio {
	// 		line-height: 30px
	// 	}
	// }
}
</style>
